import React, { useMemo } from 'react';
import { CameraIcon, ScanIcon } from 'lucide-react';
import type { OrigenArchivo } from '../../types';

/**
 * Miniatura simulada de una página digitalizada. El patrón de renglones es
 * determinista a partir de la semilla, para que cada documento se vea distinto.
 */
export function MiniaturaDocumento({
  semilla,
  origen = 'Escáner',
  rotacion = 0,
  url,
  ancho = 44,
  alto = 58,
  etiqueta
}: {
  semilla: string;
  origen?: OrigenArchivo;
  rotacion?: number;
  url?: string;
  ancho?: number;
  alto?: number;
  etiqueta?: string;
}) {
  const renglones = useMemo(() => {
    let s = 0;
    for (let i = 0; i < semilla.length; i++) s = (s * 33 + semilla.charCodeAt(i)) % 99991;
    return Array.from({
      length: 9
    }).map((_, i) => {
      s = (s * 1103515245 + 12345) % 2147483648;
      const largo = 40 + (s >> 12) % 55;
      const titulo = i === 0;
      return {
        largo: titulo ? 62 : largo,
        titulo
      };
    });
  }, [semilla]);
  const contenido = url ? <img src={url} alt="" className="h-full w-full object-cover" style={{
    transform: `rotate(${rotacion}deg)`
  }} data-id="element-327" data-mp="yuvlxbh18njq" /> : <svg viewBox="0 0 100 130" className="h-full w-full" style={{
    transform: `rotate(${rotacion}deg)`
  }} aria-hidden="true" data-id="element-328" data-mp="1w8rg8lnk5c2p">
      <rect width="100" height="130" fill="#ffffff" data-id="element-329" data-mp="25xsuo7egflek" />
      {renglones.map((r, i) => <rect key={i} x="12" y={16 + i * 12} width={r.largo} height={r.titulo ? 5 : 3} rx="1.5" fill={r.titulo ? '#0B2141' : '#CBD1DC'} data-id="element-330" data-mp="25zm5lyw3orsd" data-mpi={i} />)}
      <rect x="12" y="112" width="34" height="8" rx="1.5" fill="#E1E5EC" data-id="element-331" data-mp="2jx0xda9ttbni" />
    </svg>;
  return <span className="relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded border border-gris-300 bg-white" style={{
    width: ancho,
    height: alto
  }} title={etiqueta} data-id="element-332" data-mp="2ox6tb2n4pkbe">
      {contenido}
      <span className="absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center bg-marino-800 text-white" data-id="element-333" data-mp="ujfdtmi4c681">
        {origen === 'Cámara' ? <CameraIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-334" data-mp="hj3daumodhz4" /> : <ScanIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-335" data-mp="hl7toc1rg9ga" />}
      </span>
    </span>;
}